import { ADMIN_DASHBOARD_INSTRUCTIONS } from './constants';
import type { TPTTranslations } from './types';

export const en: TPTTranslations = {
  [ADMIN_DASHBOARD_INSTRUCTIONS]: {
    INSTRUCTIONS_STEP_1: 'Use the template in Excel',
    INSTRUCTIONS_STEP_1_LINK: 'Download template',
    INSTRUCTIONS_STEP_2:
      'Enter the email of your users.\nMaximum 500 users per upload.',
    INSTRUCTIONS_STEP_3: 'Upload the Excel file\nand click “Next”.',
  },
};
